var windshaft = require('./windshaft-errors');
var ajax = require('./ajax-errors');
var validation = require('./validation-errors');

module.exports = {
  ajax: ajax,
  windshaft: windshaft,
  validation: validation
};
